// @flow

const SERVICE_DATA_UPDATE = "service/data/update";
const SERVICE_POLYGON_SET = "service/data/polygon/update";
const SERVICE_ORIGIN_TERMINALS_SET = "service/origin/terminals/set";
const SERVICE_DEST_TERMINALS_SET = "service/dest/terminals/set";

export default {
    SERVICE_DATA_UPDATE,
    SERVICE_POLYGON_SET,
    SERVICE_ORIGIN_TERMINALS_SET,
    SERVICE_DEST_TERMINALS_SET,
};


// WEBPACK FOOTER //
// ./src/Store/Ducks/ServiceConfig/types.js